export default __webpack_public_path__ + "livi@2x.539a072c.png";